module.exports = __webpack_public_path__ + "static/media/calendar.09c6cb7f.svg";